import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";
import { API_AXIOS } from "../../http/interceptor";

export const eventRegApi = createApi({
  reducerPath: "eventRegister",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["EventRegister"],
  endpoints: (builder) => ({
    getEventRegData: builder.query({
      queryFn: async ({
        page = 1,
        limit = 20,
        search,
        city,
        country,
        startDate,
        endDate,
      }) => {
        try {
          const { data } = await API_AXIOS.get(Apis.eventRegister, {
            params: {
              page,
              limit,
              search,
              city,
              country,
              startDate,
              endDate,
            },
          });
          return { data };
        } catch (error) {
          return { error: error.response?.data || error.message };
        }
      },
      providesTags: ["EventRegister"],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetEventRegDataQuery } = eventRegApi;

export const eventRegDetailsApi = createApi({
  reducerPath: "eventRegDetails",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["eventRegDetails"],
  endpoints: (builder) => ({
    getEventRegDetails: builder.query({
      query: (id) => ({
        url: `${Apis.eventRegister}/details/${id}`,
      }),
      providesTags: ["eventRegDetails"],
      keepUnusedDataFor: 300,
      transformResponse: (data) => data.data,
    }),
  }),
});

export const { useGetEventRegDetailsQuery } = eventRegDetailsApi;
